import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

// Import all blog posts
import BestFloristsNewtownSameDay from '../../pages/blog/best-florists-newtown-same-day';
import BirthdayFlowersSydney from '../../pages/blog/birthday-flowers-sydney';
import LocalVsCorporateFlorists from '../../pages/blog/local-vs-corporate-florists';

// Map slugs to components
const blogPosts: Record<string, React.ComponentType> = {
  'best-florists-newtown-same-day': BestFloristsNewtownSameDay,
  'birthday-flowers-sydney': BirthdayFlowersSydney,
  'local-vs-corporate-florists': LocalVsCorporateFlorists,
};

export default function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  
  if (!slug || !blogPosts[slug]) {
    return <Navigate to="/blog" replace />;
  }
  
  const PostComponent = blogPosts[slug];
  return <PostComponent />;
} 